<template>
  <blank-container
    :title="$route.meta.title[$i18n.locale]"
    @addBtn="$router.push({ name: 'leadership-create' })"
  >
    <a-table
      :columns="columns"
      :data-source="$store.getters['leadership/sortedList']"
      :loading="loading"
      :pagination="{ defaultPageSize: 10 }"
      :row-key="() => Math.random().toString().slice(2)"
      class="leadership-table"
    >
      <template slot="position" slot-scope="item">
        <span class="text-center">{{ item.position }}</span>
      </template>
      <template slot="lang_title" slot-scope="item">
        <a-row align="middle" type="flex">
          <a-avatar
            :size="64"
            :src="item.avatar && filesUrl + item.avatar"
            class="mr-1x"
            icon="user"
            shape="square"
          />
          {{ item.full_name || "Не указано" }}
        </a-row>
      </template>

      <template slot="operation" slot-scope="item">
        <a-icon
          class="action-btns"
          type="edit"
          @click="
            $router.push({ name: 'leadership-detail', params: { id: item.id } })
          "
        />
        <a-popconfirm
          cancel-text="Нет"
          ok-text="Да"
          title="Вы действительно хотите удалить?"
          @confirm="removeItem(item)"
        >
          <a-icon class="action-btns" style="margin: 0 10px" type="delete" />
        </a-popconfirm>
      </template>
    </a-table>
  </blank-container>
</template>

<script>
const columns = [
  {
    title: "Поз.",
    key: "position",
    scopedSlots: { customRender: "position" },
    width: 60,
    className: "text-center font-md"
  },
  {
    title: "Ф.И.О",
    key: "title",
    scopedSlots: { customRender: "lang_title" }
  },
  {
    title: "Действие",
    key: "operation",
    scopedSlots: { customRender: "operation" },
    width: 60
  }
]

export default {
  data: () => ({
    loading: false,
    columns
  }),
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    },
    "$i18n.locale": {
      handler: "fetchData",
      immediate: true
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        await this.$store.dispatch("leadership/fetch")
      } catch (error) {
        console.log(error)
        this.loading = false
      }

      this.loading = false
    },

    async removeItem(item) {
      //todo
      try {
        const res = await this.$store.dispatch(
          "leadership/removeItemAction",
          item.id
        )

        console.log("removeItem", res)
        this.fetchData()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
